export default {
    path: 'view-report-details/:report_id?',
    name: 'report-details',
    props: function (route) {
        const payload = {
            ...new Function("return " + (JSON.stringify(route.query || {})))(),
            ...new Function("return " + (JSON.stringify(route.params || {})))()
        }
        payload.JString = new Function("return " + (payload.JString || "{}"))();
        return payload
    },
    component: () => import( /* webpackChunkName: "ViewReportDetails" */ './ModalWrapper.vue')
}